import { PrintType } from '@/types';
import { getIsScreenPrintType } from './getIsScreenPrintType';

export function getHasScreenPrintingPrintType(printTypes: PrintType[]) {
  return printTypes.length > 0 && printTypes.every(getIsScreenPrintType);
}
